<div class="pmd-footer border-top">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-12 col-md mb-2 mb-md-0">
        <div class="pmd-site-info text-md-right">
          <p>&copy; {{ currentYear }} <strong>Probanker Simulations LLC</strong></p>
          <!--               <p class="d-block">Crafted by <a href="https://www.digi-corp.com/"-->
          <!--                     target="_blank" aria-label="Cradted by Digicorp, Press enter to go to Digicorp website"><strong>DIGICORP</strong></a></p>-->
        </div>
      </div>
      <div class="col-md-auto col-12">
        <ul class="pmd-footer-nav pmd-footer-nav-divider mb-2 mb-lg-0">
          <li>
            <a
              tabindex="0"
              href="/terms-conditions"
              aria-label="Press enter to open terms of use page"
              >Terms of Use</a
            >
          </li>
          <li>
            <a
              tabindex="0"
              href="/privacy-policy"
              aria-label="Press enter to open privacy policy page"
              >Privacy Policy</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
